import React, {useEffect, useState} from "../../../_snowpack/pkg/react.js";
import styles from "./ImageCard.module.css";
const ImageCard = ({image, description}) => {
  const [isHovering, setIsHovering] = useState(false);
  useEffect(() => {
    if (isHovering) {
    }
  }, [isHovering]);
  return /* @__PURE__ */ React.createElement("div", {
    className: styles.container
  }, /* @__PURE__ */ React.createElement("img", {
    src: image,
    className: styles.imageCard,
    alt: "Generated",
    onMouseEnter: () => setIsHovering(true),
    onMouseLeave: () => setIsHovering(false)
  }), /* @__PURE__ */ React.createElement("div", {
    className: styles.overlay
  }, /* @__PURE__ */ React.createElement("text", {
    className: styles.overlayText
  }, description)));
};
export default ImageCard;
